<!-- eslint-disable max-len -->
<template>
  <v-card-text>
    <v-row>
      <!-- Past 5 Years -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title id="breakWord" class="font-weight-medium">Has anyone been treated for a disability, serious illness, been hospitalized or had surgery in the past 5 years?</v-list-item-title>
          <v-list-item-subtitle id="breakWord">{{ disabilityPast5Years }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- Employee list -->
      <div v-if="disability5Years">
        <v-col
          cols="12"
          v-for="(item, index) in past5Employees"
          :key="index"
        >
          <v-card flat style="background-color: transparent !important">
            <v-card-title class="text-body-1 font-weight-medium">Employee {{ index + 1 }}</v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <v-row>

                <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">M/F</v-list-item-title>
                    <v-list-item-subtitle>{{ item.maleOrFemale }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Employed</v-list-item-title>
                    <v-list-item-subtitle>{{ item.isEmployed }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Date of Onset</v-list-item-title>
                    <v-list-item-subtitle>{{ item.dateOfOnset }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Last Date Treated</v-list-item-title>
                    <v-list-item-subtitle>{{ item.lastDateOfTreatment }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Treatment/Drug</v-list-item-title>
                    <v-list-item-subtitle>{{ item.treatmentOrDrug }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Degree of Recovery</v-list-item-title>
                    <v-list-item-subtitle>{{ item.percentOfRecovery }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Condition</v-list-item-title>
                    <v-list-item-subtitle>{{ item.condition }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </div>

      <!-- Hospitalized by a disability -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title id="breakWord" class="font-weight-medium">Is anyone currently hospitalized, confined at home, confined in a treatment facility, and/or incapable of self-support because of physical or mental disability?</v-list-item-title>
          <v-list-item-subtitle id="breakWord">{{ hospitalizedByDisability }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- Employee list -->
      <div v-if="hospitalizedByDisability">
        <v-col
          cols="12"
          v-for="(item, index) in hospitalizedEmployees"
          :key="index"
        >
          <v-card flat style="background-color: transparent !important">
            <v-card-title class="text-body-1 font-weight-medium">Employee {{ index + 1 }}</v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <v-row>

                <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">M/F</v-list-item-title>
                    <v-list-item-subtitle>{{ item.maleOrFemale }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Employed</v-list-item-title>
                    <v-list-item-subtitle>{{ item.isEmployed }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Date of Onset</v-list-item-title>
                    <v-list-item-subtitle>{{ item.dateOfOnset }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Last Date Treated</v-list-item-title>
                    <v-list-item-subtitle>{{ item.lastDateOfTreatment }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Treatment/Drug</v-list-item-title>
                    <v-list-item-subtitle>{{ item.treatmentOrDrug }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Degree of Recovery</v-list-item-title>
                    <v-list-item-subtitle>{{ item.percentOfRecovery }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Condition</v-list-item-title>
                    <v-list-item-subtitle>{{ item.condition }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </div>

      <!-- Advised for treatment -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title id="breakWord" class="font-weight-medium">Has anyone been advised that medical treatment, diagnostic testing, surgery or hospitalization is necessary?</v-list-item-title>
          <v-list-item-subtitle id="breakWord">{{ hasBeenAdvised }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- Employee list -->
      <div v-if="hasBeenAdvised">
        <v-col
          cols="12"
          v-for="(item, index) in advisedEmployees"
          :key="index"
        >
          <v-card flat style="background-color: transparent !important">
            <v-card-title class="text-body-1 font-weight-medium">Employee {{ index + 1 }}</v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <v-row>

                <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">M/F</v-list-item-title>
                    <v-list-item-subtitle>{{ item.maleOrFemale }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Employed</v-list-item-title>
                    <v-list-item-subtitle>{{ item.isEmployed }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Date of Onset</v-list-item-title>
                    <v-list-item-subtitle>{{ item.dateOfOnset }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Last Date Treated</v-list-item-title>
                    <v-list-item-subtitle>{{ item.lastDateOfTreatment }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Treatment/Drug</v-list-item-title>
                    <v-list-item-subtitle>{{ item.treatmentOrDrug }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Degree of Recovery</v-list-item-title>
                    <v-list-item-subtitle>{{ item.percentOfRecovery }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Condition</v-list-item-title>
                    <v-list-item-subtitle>{{ item.condition }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </div>

      <!-- Conditions -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title id="breakWord" class="font-weight-medium">Is anyone currently being treated or been advised to seek treatment for any of the following:</v-list-item-title>
          <v-list-item-subtitle id="breakWord">{{ chosenConditions }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- Employee list -->
      <v-col
        cols="12"
        v-for="(item, index) in conditionEmployees"
        :key="index"
      >
        <v-card flat style="background-color: transparent !important">
          <v-card-title class="text-body-1 font-weight-medium">Employee {{ index + 1 }}</v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">M/F</v-list-item-title>
                    <v-list-item-subtitle>{{ item.maleOrFemale }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Employed</v-list-item-title>
                    <v-list-item-subtitle>{{ item.isEmployed }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Date of Onset</v-list-item-title>
                    <v-list-item-subtitle>{{ item.dateOfOnset }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Last Date Treated</v-list-item-title>
                    <v-list-item-subtitle>{{ item.lastDateOfTreatment }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Treatment/Drug</v-list-item-title>
                    <v-list-item-subtitle>{{ item.treatmentOrDrug }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Degree of Recovery</v-list-item-title>
                    <v-list-item-subtitle>{{ item.percentOfRecovery }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Condition</v-list-item-title>
                    <v-list-item-subtitle>{{ item.condition }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'BenefitsIllness',
  data: () => ({
    temp: null,
  }),
  computed: {
    employees() {
      return this.$store.state.benefitsPacket.employees;
    },
    disabilityPast5Years() {
      return this.$store.state.benefitsPacket.flags.disability5Years;
    },
    hospitalizedByDisability() {
      return this.$store.state.benefitsPacket.flags.hospitalizedByDisability;
    },
    hasBeenAdvised() {
      return this.$store.state.benefitsPacket.flags.advisedForTreatment;
    },
    chosenConditions() {
      // eslint-disable-next-line max-len
      return [...new Set(this.$store.state.benefitsPacket.employees.filter((x) => x.type === 'condition').map((x) => x.condition))].join(', ');
    },
    past5Employees() {
      return this.employees.filter((x) => x.type === 'Past5');
    },
    conditionEmployees() {
      return this.employees.filter((x) => x.type === 'condition');
    },
    hospitalizedEmployees() {
      return this.employees.filter((x) => x.type === 'hospitalized');
    },
    advisedEmployees() {
      return this.employees.filter((x) => x.type === 'advised');
    },
  },
};
</script>

<style lang="scss" scoped>
#breakWord {
  overflow: unset;
  text-overflow: unset;
  white-space: unset;
  word-break: break-word;
}
</style>
